import setupAQSButtons from '../../../../bifrost/assets/js/src/modules/_aqsbuttons';
let number = '';
let ads = '';
const resAds = [];
const resIndex = [];
const busIndex = [];
const busAds = [];

function setPosition() {
    $('.tabs-panel.is-active .provider-card--item:not([data-type="Ad"])').each(
        (i, el) => {
            el.dataset.position = i + 1;
            const links = $(el).find('a');
            links.each((x, link) => {
                link.dataset.position = i + 1;
            });
        }
    );
    $('.tabs-panel.is-active .provider-card--item').each((i, el) => {
        el.dataset.globalPosition = i + 1;
        const links = $(el).find('a');
        links.each((x, link) => {
            link.dataset.globalPosition = i + 1;
        });
    });
}

const changeSort = (type) => {
    const divs = $('.tabs-panel');

    divs.addClass('has-sorted'); // needed to not show card animations twice
    $('.tabs-content').addClass('has-sorted');

    $.each(divs, (k, panel) => {
        // pull ads out
        if (panel.dataset.type === 'Residential') {
            ads = $('#residential .provider-ads');
            ads.remove();
        }

        const cards = $(panel).find('.provider-card--item');

        if (panel.dataset.type === 'Residential') {
            for (let i = 0; i < cards.length; i++) {
                if (
                    cards[i].classList.contains('secondary-card') &&
                    panel.dataset.type === 'Residential'
                ) {
                    resIndex.push(i);
                    resAds.push(cards[i]);
                    cards.splice(i, 1);
                }
            }
        } else if (panel.dataset.type === 'Business') {
            for (let i = 0; i < cards.length; i++) {
                if (
                    cards[i].classList.contains('secondary-card') &&
                    panel.dataset.type === 'Business'
                ) {
                    busIndex.push(i);
                    busAds.push(cards[i]);
                    cards.splice(i, 1);
                }
            }
        }

        // sort by availability first
        cards.sort(
            (a, b) =>
                $(b).data('listing-availability') -
                $(a).data('listing-availability')
        );

        if (type === 'speed') {
            cards.sort(
                (a, b) =>
                    $(b).data('listing-speed') - $(a).data('listing-speed')
            );
        } else if (type === 'availability') {
            cards.sort(
                (a, b) =>
                    $(b).data('listing-availability') -
                    $(a).data('listing-availability')
            );
        } else if (type === 'hsiRating') {
            cards.sort(
                (a, b) => $(b).data('listing-hsi') - $(a).data('listing-hsi')
            );
        } else if (type === 'userRating') {
            cards.sort(
                (a, b) => $(b).data('listing-user') - $(a).data('listing-user')
            );
        } else if (type === 'recommended') {
            cards.sort(
                (a, b) =>
                    $(a).data('listing-recommended') -
                    $(b).data('listing-recommended')
            );
        }

        cards.each((i, el) => {
            number = $(el).find('.number');
            number.html(`${i + 1}`);
        });

        // inserts the ads back into the original position index
        if (panel.dataset.type === 'Residential') {
            for (let i = 0; i < resAds.length; i++) {
                cards.splice(resIndex[i], 0, resAds[i]);
            }
        } else if (panel.dataset.type === 'Business') {
            for (let i = 0; i < busAds.length; i++) {
                cards.splice(busIndex[i], 0, busAds[i]);
            }
        }

        setPosition();

        $(panel).html(cards);

        // put the ads back on top
        if (panel.dataset.type === 'Residential') {
            $('#residential .provider-card--item:first').before(ads);

            ads.each((i, el) => {
                const links = $(el).find('a');
                links.each((x, link) => {
                    link.dataset.position = i + 1;
                });
            });
        }

        if (panel.dataset.type === 'Business') {
            $('#business .provider-card--item:first').before(ads);

            ads.each((i, el) => {
                const links = $(el).find('a');
                links.each((x, link) => {
                    link.dataset.position = i + 1;
                });
            });
        }
    });
};

const init = () => {
    // changeSort('recommended');

    setPosition();

    $('select[name="sortby"]').change((e) => {
        $('.tabs-panel').addClass('add-animate');
        const type = $(e.currentTarget).val();
        changeSort(type);
    });

    // change the tab when the select is updated
    $('select[name="tab-select"]').on('change', (e) => {
        $(`.tabs-title a[aria-controls="${$(e.currentTarget).val()}"]`).click();
    });

    // object to check if cards have already been pushed
    const pushedTypes = {
        Residential: false,
        Business: false,
        Mobile: false,
        Ad: false,
    };

    /* eslint-disable */
    function pushImpressions(cards) {
        let nonAdPosition = 1;
        let adPosition = 1;
        cards.each((i, el) => {
            let cardBrand = el.dataset.brand;
            const cardType = el.dataset.type;

            if (cardBrand === 'Xfinity') {
                // report Xfinity as Comcast
                cardBrand = 'Comcast';
            }

            if (pushedTypes[cardType] === false) {
                dataLayer.push({
                    event: 'brandImpression',
                    brand: cardBrand,
                    position: cardType === 'Ad' ? adPosition : nonAdPosition,
                    globalPosition: i + 1,
                    type: cardType,
                });
                if (cardType === 'Ad') {
                    adPosition++;
                } else {
                    nonAdPosition++;
                }
            }
        });
    }

    /* eslint-enable */

    // wait for dataLayer to be defined
    (async () => {
        while (
            !window.hasOwnProperty('dataLayer') &&
            !window.hasOwnProperty('ga.create')
        ) {
            await new Promise((resolve) => setTimeout(resolve, 250));
        }
        // removing brand impressions per request from Nish 6-4-24
        // push first cards shown
        // setTimeout(() => {
        //     const adCards = $('.tabs-panel.is-active').find(
        //         '.provider-card--item[data-type="Ad"]'
        //     );
        //     const allCards = $('.tabs-panel.is-active').find(
        //         '.provider-card--item'
        //     );

        // const firstCardsType = $('.tabs-panel.is-active').data('type');
        // pushImpressions(allCards);
        // if (adCards.length > 0) {
        //     pushedTypes.Ad = true;
        // }
        // pushedTypes[firstCardsType] = true;
        // }, 1000);
    })();

    // push cards on tab change
    $('#providerTabs').on('change.zf.tabs', () => {
        setPosition();

        $('.tabs-panel').addClass('add-animate');
        // const activeTab = $(e.currentTarget).find('.is-active a').attr('href');
        // const cards = $(activeTab).find('.provider-card--item');
        // const thisType = $(activeTab).data('type');

        // removing brand impressions per request from Nish 6-4-24
        // if (pushedTypes[thisType] === false) {
        //     pushImpressions(cards);
        //     pushedTypes[thisType] = true;
        // }
    });

    $(document).on('click', '.geo-zip__button', (e) => {
        $(e.currentTarget).toggleClass('btn-active');
        $('.geo-banner__title, .geo-banner__form').toggleClass('active');
        $('.geo-banner__form.active input').focus(); // need to only do this if form has active class
    });

    $(document).on('submit', '.geo-banner__form', (e) => {
        $(e.currentTarget)
            .prev('.geo-zip__button')
            .removeClass('btn-active')
            .addClass('btn-spin');
        $('.ball-spin-fade-loader').addClass('active');
    });

    $(document).on('blur', '#banner-zip', (e) => {
        // because iOS isn't very good
        if (e.currentTarget.value.length === 5) {
            $('.geo-banner__form').submit();
        }
    });

    function toggleStars() {
        if ($('.hidden-providers').hasClass('active')) {
            $('.hidden-providers').removeClass('active');
        } else {
            setTimeout(() => {
                $('.hidden-providers').addClass('active');
            }, 333);
        }
    }

    $(document).on('click', '.see-more-providers', () => {
        $('.hidden-providers').slideToggle(333, toggleStars());
        $('.see-more-providers, .see-more-providers__swap').toggleClass(
            'active'
        );
    });

    $(document).ready(function () {
        const compareProvidersSelect = $('.providers-compare__select');
        if (compareProvidersSelect.length > 0) {
            compareProvidersSelect.change();
        }
    });

    $(document).on('change', '.providers-compare__select', (e) => {
        const selectedProvider =
            e.currentTarget.options[e.currentTarget.selectedIndex];
        const providerSet = e.currentTarget.name;

        // disable provider on opposite select
        if (providerSet === 'providers-compare__set1') {
            $('select[name="providers-compare__set2"] option').removeAttr(
                'disabled'
            );
            $(
                `select[name="providers-compare__set2"] option[value="${selectedProvider.value}"]`
            ).attr('disabled', 'disabled');
        } else {
            $('select[name="providers-compare__set1"] option').removeAttr(
                'disabled'
            );
            $(
                `select[name="providers-compare__set1"] option[value="${selectedProvider.value}"]`
            ).attr('disabled', 'disabled');
        }

        $(`.${providerSet} option`).removeAttr('data-box');

        $(`.${providerSet}__speed`).html(selectedProvider.dataset.speed);
        $(`.${providerSet}__connection`).html(
            selectedProvider.dataset.connection
        );

        // check if provider has a rating
        if (selectedProvider.dataset.rating === '0.0') {
            $(`.${providerSet}__rating--na`).removeClass('hidden');
            $(`#${providerSet}__ratingStars`).hide();
        } else {
            $(`.${providerSet}__rating--na`).addClass('hidden');
            $(`#${providerSet}__ratingStars`).show();
        }

        $(`.${providerSet}__ratingStars`).data(
            'clickedon',
            selectedProvider.dataset.rating
        );
        $(`.${providerSet}__rating-total`).html(
            selectedProvider.dataset.ratingTotal
        );
        $(`input[name='${providerSet}__rating']`).removeAttr('disabled');
        $(
            `input[name='${providerSet}__rating'][value='${selectedProvider.dataset.rating}']`
        ).click();
        $(`input[name='${providerSet}__rating']`).attr('disabled', 'disabled');

        const providerCard = $(
            `.provider-card[data-type="Residential"][data-slug='${selectedProvider.dataset.slug}']`
        );

        // Clone and modify elements
        const providerLogo = providerCard
            .find('.provider-card-item-logo')
            .contents()
            .clone()
            .removeAttr('data-aqsran');
        providerLogo.find('img').addClass('provider-logo-image');

        const providerViewPlans = providerCard
            .find('.provider-card-item-button')
            .clone();
        providerViewPlans
            .find('.button')
            .removeClass('large')
            .addClass('wide')
            .removeAttr('data-aqsran');

        // Update target elements
        $(`.${providerSet}__logo`).html(providerLogo);
        $(`.${providerSet}__links`).html(providerViewPlans);

        // Run additional setup if available
        if (typeof setupAQSButtons === 'function') {
            setupAQSButtons(); // eslint-disable-line no-undef
        }
    });
};

// Export public methods
export { init };
